import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { API_URL } from "../../utils/constant";

// Async Thunks
export const fetchAssets = createAsyncThunk("assets/fetchAssets", async (id) => {
    const response = await axios.get(`${API_URL}/assets/${id}`);
    return response.data.data; // Assuming response structure { success: true, data: [...] }
});

export const addAsset = createAsyncThunk("assets/addAsset", async (asset) => {
    const response = await axios.post(`${API_URL}/assets`, asset);
    return response.data.data;
});

export const updateAsset = createAsyncThunk("assets/updateAsset", async ({ id, updatedData }) => {
    const response = await axios.put(`${API_URL}/assets/${id}`, updatedData);
    return response.data.data;
});

export const deleteAsset = createAsyncThunk("assets/deleteAsset", async (id) => {
    await axios.delete(`${API_URL}/assets/${id}`);
    return id;
});

// Create Slice
const assetsSlice = createSlice({
    name: "assets",
    initialState: {
        assets: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchAssets.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchAssets.fulfilled, (state, action) => {
                state.loading = false;
                state.assets = action.payload;
            })
            .addCase(fetchAssets.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(addAsset.fulfilled, (state, action) => {
                state.assets.push(action.payload);
            })
            .addCase(updateAsset.fulfilled, (state, action) => {
                const index = state.assets.findIndex(asset => asset.id === action.payload.id);
                if (index !== -1) {
                    state.assets[index] = action.payload;
                }
            })
            .addCase(deleteAsset.fulfilled, (state, action) => {
                state.assets = state.assets.filter(asset => asset.id !== action.payload);
            });
    },
});

export default assetsSlice.reducer;
